var map = {
	"./burst1.png": 1852,
	"./burst10.png": 6070,
	"./burst11.png": 5087,
	"./burst12.png": 596,
	"./burst13.png": 3629,
	"./burst14.png": 9378,
	"./burst15.png": 507,
	"./burst16.png": 9216,
	"./burst17.png": 5465,
	"./burst18.png": 3550,
	"./burst19.png": 9127,
	"./burst2.png": 6135,
	"./burst20.png": 5975,
	"./burst3.png": 3118,
	"./burst4.png": 5585,
	"./burst5.png": 968,
	"./burst6.png": 5459,
	"./burst7.png": 6602,
	"./burst8.png": 669,
	"./burst9.png": 9540
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7086;